import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Alert from "@mui/material/Alert";
import { GLOBAL_PRESENCE_OPTIONS, GlobalPresenceOption } from "./constants";
import { LocationSelector } from "./LocationSelector";
import { useGlobalPresenceFilter } from "./hooks/useGlobalPresenceFilter";
import { useInsideFilterChip } from "../../../../pages/Workspace/UserFilters/FiltersChips/hooks/useInsideFilterChip";

export const GlobalPresenceFilter = () => {
  const {
    selectedOption,
    showHQSelector,
    showSubsidiarySelector,
    hqLocationType,
    hqLocationValues,
    subsidiaryLocationType,
    subsidiaryLocationValues,
    subsidiaryMatchType,
    shouldShowNote,
    handleOptionChange,
    handleAddHQLocations,
    handleAddSubsidiaryLocations,
    handleHQLocationTypeChange,
    handleHQLocationValuesChange,
    handleSubsidiaryLocationTypeChange,
    handleSubsidiaryLocationValuesChange,
    handleSubsidiaryMatchTypeChange,
    handleCloseHQSelector,
    handleCloseSubsidiarySelector,
    handleClearFilter,
  } = useGlobalPresenceFilter();

  const { insideChip, elementRef } = useInsideFilterChip();

  return (
    <Box id="global-presence-filter" ref={elementRef}>
      {!insideChip && (
        <>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="h5">Global Presence</Typography>
            <Button size="medium" variant="text" onClick={handleClearFilter}>
              Clear
            </Button>
          </Stack>
          <Typography variant="caption" fontWeight="bold">
            Select How You Want to Filter
          </Typography>
        </>
      )}

      <RadioGroup value={selectedOption} onChange={handleOptionChange}>
        {GLOBAL_PRESENCE_OPTIONS.map((option) => (
          <FormControlLabel
            key={option.value}
            value={option.value}
            control={<Radio />}
            label={option.label}
          />
        ))}
      </RadioGroup>

      {selectedOption === GlobalPresenceOption.BY_LOCATION && (
        <Box width="100%">
          <Stack direction="column" spacing={1} mt={1}>
            {/* HQ Section */}
            {!showHQSelector ? (
              <Button
                variant="outlined"
                onClick={handleAddHQLocations}
                fullWidth
              >
                + ADD HEADQUARTER LOCATIONS
              </Button>
            ) : (
              <LocationSelector
                title="Headquarters"
                onClose={handleCloseHQSelector}
                onLocationTypeChange={handleHQLocationTypeChange}
                onLocationValuesChange={handleHQLocationValuesChange}
                initialLocationType={hqLocationType}
                initialLocationValues={hqLocationValues}
              />
            )}

            {/* Subsidiary Section */}
            {!showSubsidiarySelector ? (
              <Button
                variant="outlined"
                onClick={handleAddSubsidiaryLocations}
                fullWidth
              >
                + ADD SUBSIDIARY LOCATIONS
              </Button>
            ) : (
              <LocationSelector
                title="Subsidiaries"
                showMatchSelector
                onClose={handleCloseSubsidiarySelector}
                onLocationTypeChange={handleSubsidiaryLocationTypeChange}
                onLocationValuesChange={handleSubsidiaryLocationValuesChange}
                onMatchTypeChange={handleSubsidiaryMatchTypeChange}
                initialLocationType={subsidiaryLocationType}
                initialLocationValues={subsidiaryLocationValues}
                initialMatchType={subsidiaryMatchType}
              />
            )}
          </Stack>
        </Box>
      )}

      {shouldShowNote && (
        <Box mt={2}>
          <Alert severity="info" sx={{ alignItems: "center" }}>
            Note: The results will contain the entire hierarchy of a company
            that matches the selected criteria
          </Alert>
        </Box>
      )}
    </Box>
  );
};
